// tslint:disable: no-unused-expression
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

import { WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';

import { WebAPIService } from 'src/app/services/webapi/web-api.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

import { IDeviceInfo } from 'src/app/interfaces/IDeviceInfo';
import { VisitaService } from 'src/app/services/visita/visita.service';

declare var $: any;

@Component({
  selector: 'app-test',
  templateUrl: './test.page.html',
  styleUrls: ['./test.page.scss'],
})
export class TestPage implements OnInit {

  public _token: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public paypal: any;

  constructor(private _route: ActivatedRoute,
              public _usuarioSrv: UsuarioService,
              public _webAPISrv: WebAPIService,
              public _deviceInfoSrv: DeviceInfoService,
              public _visitaSrv: VisitaService) {

    // tslint:disable-next-line: no-unused-expression
    // window['paypal'].Buttons({
    //   // Set up the transaction
    //   createOrder: (data, actions) => {

    //     console.log('PayPal.createOrder');
    //     console.log(data);
    //     console.log(actions);

    //     return actions.order.create({
    //       purchase_units: [{
    //         amount: {
    //           value: 99.99
    //         }
    //       }]
    //     });
    //   },

    //   // Finalize the transaction
    //   onApprove: (data, actions) => {

    //     console.log('PayPal.onApprove');
    //     console.log(data);
    //     console.log(actions);

    //     return actions.order.capture()
    //       .then((details) => {

    //         alert('onApprove');
    //         console.log(details);

    //       })
    //       .catch(err => {

    //         console.log('PayPal Error >> ');
    //         console.log(err);
    //         console.log(data);
    //         console.log(actions);

    //       });
    //   }
    // }).render('#paypal-button-container') as any;

    window['paypal'].Buttons().render('#paypal-button-container') as any;
  }

  public ngOnInit() {
    $('#btn').click(() => {
      alert('Hello fromJQuery');
    });

    $('#preloader').animate({
      opacity: '0'
    }, 600, () => {
      setTimeout(() => {
          $('#preloader').css('visibility', 'hidden').fadeOut();
      }, 300);
    });

  }

  public openSite(width: number) {
    window.open('http://localhost:8400/', '_blank', 'width=' + width + ',height=600');
  }

  public async getToken() {
    const item = await Storage.get({
      key: 'token'
    });

    console.log('getTokenFromWebAPI >> item >> ' + JSON.stringify(item));
    const devInfo: IDeviceInfo = JSON.parse(item.value);
    console.log('getTokenFromWebAPI >> devInfo >> ' + JSON.stringify(devInfo));

    if (devInfo == null) {
      this._token = 'null';
    } else {
      this._token = devInfo.Token;
    }
  }

  public async setToken() {
    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();
    this._token = this._deviceInfoSrv.CurrentDeviceInfo.Token;
  }

  public delToken() {
    this._usuarioSrv.delPublicToken().then(() => {
      this._token = 'null';
    });
  }

  public async registrarVisita() {

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Test', null, null,
      null, null, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe(() => {
          this._token = this._deviceInfoSrv.CurrentDeviceInfo.Token;
        });
    });
  }
}
